// Gratis-app-actie (t/m 31 aug): de Baby & Slaap Tracker app komt automatisch
// in de cart zodra er een fysiek product in zit, en gaat er weer uit als het
// laatste fysieke product verdwijnt. Haalt de klant de app zelf weg, dan
// blijft hij deze sessie weg. De 100%-korting komt van de automatic discount
// "Baby & Slaap Tracker app lifetime gratis".
(function () {
  if (window.numsyFreeAppGift) return;

  const holder = document.querySelector('[data-free-app-gift]');
  if (!holder) return;
  window.numsyFreeAppGift = true;

  const APP_VARIANT = parseInt(holder.getAttribute('data-app-variant'), 10);
  const APP_PRODUCT = parseInt(holder.getAttribute('data-app-product'), 10);
  const OPT_OUT_KEY = 'numsy-app-gift-removed';
  let busy = false;

  const routes = (window.theme && theme.routes) || {};
  const cartUrl = routes.cart_url || '/cart';
  const addUrl = routes.cart_add_url || '/cart/add';
  const changeUrl = routes.cart_change_url || '/cart/change';

  const bundleSections = () => {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));
    return sections;
  };

  const publish = async (sections) => {
    const cartJson = await (await fetch(`${cartUrl}.js`)).json();
    cartJson['sections'] = sections || {};
    theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'free-app-gift', cart: cartJson });
  };

  const post = async (url, body) => {
    const response = await fetch(`${url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    });
    if (!response.ok) throw new Error(`free-app-gift: ${url} gaf ${response.status}`);
    return response.json();
  };

  const sync = async (cart) => {
    if (busy) return;

    try {
      if (!cart || !cart.items) cart = await (await fetch(`${cartUrl}.js`)).json();
    } catch (error) {
      return;
    }

    const appItem = cart.items.find((item) => item.product_id === APP_PRODUCT);
    const hasPhysical = cart.items.some((item) => item.product_id !== APP_PRODUCT && item.requires_shipping);

    if (hasPhysical && !appItem && !sessionStorage.getItem(OPT_OUT_KEY)) {
      busy = true;
      try {
        const sections = bundleSections();
        const parsed = await post(addUrl, { items: [{ id: APP_VARIANT, quantity: 1 }], sections: sections.join(',') });
        await publish(parsed.sections);
      } catch (error) {
        console.log(error);
      } finally {
        busy = false;
      }
    }
    else if (!hasPhysical && appItem) {
      busy = true;
      try {
        const sections = bundleSections();
        const parsed = await post(changeUrl, { id: appItem.key, quantity: 0, sections: sections.join(',') });
        await publish(parsed.sections);
      } catch (error) {
        console.log(error);
      } finally {
        busy = false;
      }
    }
    else if (appItem && appItem.quantity > 1) {
      // het cadeau is altijd 1 stuk; race of dubbele add wordt teruggezet
      busy = true;
      try {
        const sections = bundleSections();
        const parsed = await post(changeUrl, { id: appItem.key, quantity: 1, sections: sections.join(',') });
        await publish(parsed.sections);
      } catch (error) {
        console.log(error);
      } finally {
        busy = false;
      }
    }
  };

  // klant haalt de app zelf weg -> deze sessie niet opnieuw toevoegen
  document.addEventListener('click', (event) => {
    const link = event.target.closest && event.target.closest('a[is="cart-remove-button"]');
    if (!link) return;
    const row = link.closest('[data-variant-id]');
    if (row && parseInt(row.getAttribute('data-variant-id'), 10) === APP_VARIANT) {
      sessionStorage.setItem(OPT_OUT_KEY, '1');
    }
  }, true);

  theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (event && event.source === 'free-app-gift') return;
    sync(event && event.cart);
  });
  document.addEventListener('cart:refresh', () => sync());
  document.addEventListener('cart:updated', (event) => sync(event.detail && event.detail.cart));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => sync());
  } else {
    sync();
  }
})();
